<template>
	<AppDialog
		overflowHidden
		closeRight="0"
		closeTop="-30"
		disableMaxWidth
		class="app-dialog"
		ref="dialog_container"
		dialogName="SettingsDialog"
		width="1300"
	>
		<SettingsRouter :routeName="routeName" />
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import SettingsRouter from '@/components/Settings/SettingsRouter.vue';

export default {
	name: 'SettingsDialog',
	props: { routeName: { type: String } },
	components: { AppDialog, SettingsRouter },
};
</script>
